import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DesktopAppComponent } from './layouts/desktop/core-desktop/components/desktop-app/desktop-app.component';
import { MobileAppComponent } from './layouts/mobile/mobile-app/mobile-app.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { KeycloakGuard } from './shared/guards/keycloak.guard';

const routes: Routes = [
  { path: 'desktop', component: DesktopAppComponent },
  { path: 'mobile', component: MobileAppComponent },
  { path: '', redirectTo: 'desktop', pathMatch: 'full' },
  {
    path: 'admin',
    loadChildren: () => import('./layouts/desktop/admin-desktop/admin-desktop.module').then(m => m.AdminDesktopModule),
    canActivate: [AuthGuard]
  },
  // Ajoutez d'autres routes si nécessaire
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
